(() => {
  const q = (sel, root = document) => root.querySelector(sel);

  function readProgress(root = document) {
    const el = q('#ep-frozen-shipping', root);
    if (!el) return null;

    const hasFrozen = el.dataset.hasFrozen === '1';
    const frozenGrams = parseInt(el.dataset.frozenGrams || '0', 10) || 0;
    const minGrams = parseInt(el.dataset.minGrams || '0', 10) || 0;

    const blocked = hasFrozen && frozenGrams > 0 && minGrams > 0 && frozenGrams < minGrams;
    return { blocked };
  }

  function setBlockedUI(root = document) {
    const st = readProgress(root);
    if (!st) return;

    // Drawer checkout
    const drawer = q('#CartDrawer', root) || root;
    const drawerBtn = q('#CartDrawer-Checkout', drawer);
    if (drawerBtn) {
      drawerBtn.toggleAttribute('disabled', st.blocked);
      drawerBtn.classList.toggle('ep-checkout--blocked', st.blocked);
      drawerBtn.setAttribute('aria-disabled', st.blocked ? 'true' : 'false');
    }

    // Drawer express checkout container (themes vary)
    const drawerExpress =
      q('#CartDrawer .cart__dynamic-checkout-buttons', root) ||
      q('#CartDrawer [data-shopify-buttoncontainer]', root);

    if (drawerExpress) drawerExpress.style.display = st.blocked ? 'none' : '';

    // Cart page checkout
    const pageBtn = q('#checkout', root);
    if (pageBtn) {
      pageBtn.toggleAttribute('disabled', st.blocked);
      pageBtn.classList.toggle('ep-checkout--blocked', st.blocked);
      pageBtn.setAttribute('aria-disabled', st.blocked ? 'true' : 'false');

      const pageExpress =
        pageBtn.closest('.cart__ctas')?.nextElementSibling?.classList?.contains('cart__dynamic-checkout-buttons')
          ? pageBtn.closest('.cart__ctas').nextElementSibling
          : q('.cart__dynamic-checkout-buttons', root);

      if (pageExpress) pageExpress.style.display = st.blocked ? 'none' : '';
    }

    // Avoid duplicate submit handlers
    const forms = [q('#CartDrawer-Form', root), q('form#cart', root)].filter(Boolean);
    forms.forEach((form) => {
      if (form.dataset.epLockBound === '1') return;
      form.dataset.epLockBound = '1';

      form.addEventListener(
        'submit',
        (e) => {
          const st2 = readProgress(document);
          if (st2?.blocked) e.preventDefault();
        },
        { capture: true }
      );
    });
  }

  // Inject CSS once
  if (!document.getElementById('ep-fz-lock-css')) {
    const css = document.createElement('style');
    css.id = 'ep-fz-lock-css';
    css.textContent = `
      .ep-checkout--blocked{opacity:.55!important;cursor:not-allowed!important;pointer-events:none!important;}
    `;
    document.head.appendChild(css);
  }

  // Safety net: block any checkout link click if blocked
  document.addEventListener(
    'click',
    (e) => {
      const st = readProgress(document);
      if (!st?.blocked) return;

      const a = e.target.closest?.('a[href*="/checkout"]');
      const btn = e.target.closest?.('button[name="checkout"], button[type="submit"][name="checkout"]');
      if (a || btn) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    },
    true
  );

  // Run now + observe DOM updates (drawer Ajax re-renders)
  const run = () => setBlockedUI(document);

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { subtree: true, childList: true });
})();
